export default __webpack_public_path__ + "static/media/loginBG.a0b6b1ee.jpg";